import * as tslib_1 from "tslib";
import * as React from 'react';
import { TextField, Checkbox } from 'material-ui';
import { observer, inject } from 'mobx-react';
import DocumentationApi from 'src/services/DocumentationApi';
import { DEVELOPER_DOCUMENTATION_CREATE_ERROR } from 'src/constants/errors';
import CreateButton from 'src/components/CreateButton';
import TaskSurvey from './TaskSurvey';
var styles = {
    container: {
        padding: '1rem'
    },
    text: {
        width: '100%',
        fontSize: '14px'
    },
    code: {
        fontFamily: "consolas"
    },
    toggle: {
        float: 'right',
        marginBottom: '-60px',
        zIndex: 100
    }
};
var TaskDocumentation = /** @class */ (function (_super) {
    tslib_1.__extends(TaskDocumentation, _super);
    function TaskDocumentation(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSubmit = function (e) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        e.preventDefault();
                        return [4 /*yield*/, DocumentationApi.update(this.state.documentation)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.handleCreate = function () { return tslib_1.__awaiter(_this, void 0, void 0, function () {
            var documentation, e_1;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, DocumentationApi.create(this.props.userStore.userId, this.props.task.competencyId)];
                    case 1:
                        documentation = _a.sent();
                        this.setState({ documentation: documentation });
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _a.sent();
                        this.props.userStore.notify(DEVELOPER_DOCUMENTATION_CREATE_ERROR);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            documentation: null
        };
        return _this;
    }
    TaskDocumentation.prototype.componentWillMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var competencyId, documentation;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        competencyId = this.props.task.competencyId;
                        return [4 /*yield*/, DocumentationApi.get(competencyId)];
                    case 1:
                        documentation = _a.sent();
                        this.setState({ documentation: documentation });
                        return [2 /*return*/];
                }
            });
        });
    };
    TaskDocumentation.prototype.componentWillUnmount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.state.documentation) return [3 /*break*/, 2];
                        return [4 /*yield*/, DocumentationApi.update(this.state.documentation)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    TaskDocumentation.prototype.handleChange = function (key, value) {
        this.state.documentation.update(key, value);
    };
    TaskDocumentation.prototype.render = function () {
        var _this = this;
        if (!this.state.documentation) {
            return (React.createElement("div", { style: { display: 'flex', justifyContent: 'center' } },
                React.createElement(CreateButton, { onClick: this.handleCreate }, "Dokument\u00E1ci\u00F3 k\u00E9sz\u00EDt\u00E9se"),
                React.createElement(TaskSurvey, { task: this.props.task })));
        }
        var documentation = this.state.documentation;
        return (React.createElement(React.Fragment, null,
            React.createElement(TaskSurvey, { task: this.props.task }),
            React.createElement("form", { onSubmit: this.handleSubmit, style: styles.container },
                React.createElement(Checkbox, { label: "Friss\u00EDt\u00E9s \u00E9s csomag", style: { fontSize: '13px' }, checked: documentation.isPackage, onCheck: function (e, checked) { return _this.handleChange('isPackage', checked); } }),
                this.renderPackageDetail(),
                React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, floatingLabelText: "Verzi\u00F3k\u00F6vet\u00E9s link", value: documentation.versionControlLink, onChange: function (e, value) { return _this.handleChange('versionControlLink', value); } }),
                React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, floatingLabelText: "C\u00EDmk\u00E9k", value: documentation.tags, onChange: function (e, value) { return _this.handleChange('tags', value); } }),
                this.renderScript(),
                React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, floatingLabelText: "Le\u00EDr\u00E1s", multiLine: true, value: documentation.description, onChange: function (e, value) { return _this.handleChange('description', value); } }),
                React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, floatingLabelText: "Tesztel\u00E9si utas\u00EDt\u00E1s", multiLine: true, value: documentation.note, onChange: function (e, value) { return _this.handleChange('note', value); } }))));
    };
    TaskDocumentation.prototype.renderScript = function () {
        var _this = this;
        var documentation = this.state.documentation;
        return React.createElement(TextField, { style: tslib_1.__assign({}, styles.text, styles.code), floatingLabelFixed: true, floatingLabelText: "Szkript", multiLine: true, value: documentation.script, onChange: function (e, value) { return _this.handleChange('script', value); } });
    };
    TaskDocumentation.prototype.renderPackageDetail = function () {
        var _this = this;
        var documentation = this.state.documentation;
        if (!documentation.isPackage) {
            return null;
        }
        return (React.createElement("div", { style: { margin: '0 1rem' } },
            React.createElement(TextField, { style: styles.text, floatingLabelFixed: true, floatingLabelText: "Csomagverzi\u00F3", value: documentation.package, onChange: function (e, value) { return _this.handleChange('package', value); } }),
            React.createElement(Checkbox, { label: "Konfigur\u00E1l\u00E1s sz\u00FCks\u00E9ges", style: { fontSize: '13px' }, checked: documentation.isConfiguration, onCheck: function (e, checked) { return _this.handleChange('isConfiguration', checked); } })));
    };
    TaskDocumentation = tslib_1.__decorate([
        inject('userStore'),
        observer
    ], TaskDocumentation);
    return TaskDocumentation;
}(React.Component));
export default TaskDocumentation;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskDocumentation.tsx
// module id = 741
// module chunks = 0